"use client";
/**
 * @file 广告埋点组件
 */
import { useEffect, useState } from "react";
import CriteoAd from "@/src/components/LoadAnalysis/analysis/criteo";
import acquisition from "@/src/components/LoadAnalysis/analysis/DataAcquisition";
import { getEnv } from "@/src/utils/configUtils";
import { AddFlow, flowSpcice } from "@/src/utils";
import { getLocalItem } from "@/lib/commonService";
import {
    tagManagerInit,
    zendeskLoad,
    obAdvLoad,
    snaptrLoad,
    newTikTokPixelLoad,
    fbPixelLoadInit,
    GoogleAnalytics,
} from "./utils";
import newTiktokPixel from "./analysis/newTiktokPixel";
import pintrkPixel from "./analysis/PintrkPixel";
import { includeGaPath } from "./analysis/gaLib/ga";
import { getVistorId } from "@/src/models/customerShow";
import { isLogin } from "@/src/models/loginModel";
import personalizeEvents, { getUid } from "@/src/models/personalize";
import Kwai from "./analysis/KwaiPixel";
import axon from "./analysis/axon";
import cybertargeter from "./analysis/Cybertargeter";

/**
 * 统一的分析埋点初始化入口
 * @returns
 */
const LoadAnalysis = (props: any) => {
    const { host, route } = props;
    const [GTM_ID, setGTM_ID] = useState();
    useEffect(() => {
        setTimeout(() => {
            const GTMId = getEnv("GTM_ID", host);
            GTMId && setGTM_ID(GTMId);

            // tiktok
            newTiktokPixel.init(host);
            newTikTokPixelLoad(host);

            cybertargeter.init(host);

            // ck
            acquisition.init();
            // pintrk
            pintrkPixel.init(host);
            // fb
            fbPixelLoadInit(host);
            // tagManager
            tagManagerInit(host);
            // 千人千面埋点·
            personalizeEvents.init(host);
            // ze-snippet
            zendeskLoad(host);
            obAdvLoad(host);
            snaptrLoad(host);

            // 快手
            Kwai.init(host);

            CriteoAd.init();

            axon.init(host);

            const visitorId = getVistorId();
            if (visitorId) {
                if (!isLogin()) {
                    const uid = getUid();
                    const userId = uid ? "U" + uid : "V" + visitorId;
                    acquisition.login("UserId ", userId);
                }
            }
            // 流量归因
            const flow1 = getLocalItem("flow1");
            flow1 && flowSpcice.init(false, flow1);

            if (!includeGaPath("/" + route)) {
                GoogleAnalytics();
            }
        }, 0);
        setTimeout(() => {
            AddFlow.init();
        }, 1000);
    }, []);

    return (
        <>
            <noscript>
                <img
                    alt=""
                    height="1"
                    width="1"
                    style={{ borderStyle: "none" }}
                    src="//googleads.g.doubleclick.net/pagead/viewthroughconversion/866886311/?guid=ON&amp;script=0"
                />
            </noscript>
            {GTM_ID && (
                <noscript>
                    <iframe
                        src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
                        height="0"
                        width="0"
                        style={{ display: "none", visibility: "hidden" }}
                    ></iframe>
                </noscript>
            )}
        </>
    );
};

export default LoadAnalysis;
